<template>
  <div class="text-center py-12">
    <div class="max-w-md mx-auto">
      <h2 class="text-3xl font-bold mb-6 tracking-wide">Thank You!</h2>
      <p class="text-lg text-gray-700 mb-8 tracking-wide leading-relaxed">
        We've received your request for a free trial. Our team will contact you shortly to schedule your first session.
      </p>
      <ButtonLink 
        text="Return Home"
        url="/"
        color="black"
      />
    </div>
  </div>
</template>

<script>
import ButtonLink from '../Common/ButtonLink.vue'

export default {
  name: 'SubmissionSuccess',
  components: {
    ButtonLink
  }
}
</script> 